import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class LoginStrat extends Strategy {
    public hasCondition(request: OperationRequest): boolean {
        const requiredLogin = request?.requiredLogin;
        if (requiredLogin) return true;
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        this.pathToGo = Routes.LOGIN;
    }
}
